export async function getBlogIndex() {
  const response = await fetch(`${process.env.PUBLIC_URL || ""}/blog-index.json`);
  if (!response.ok) {
    throw new Error("Could not load blog index.");
  }

  const payload = await response.json();
  const posts = Array.isArray(payload?.posts) ? payload.posts : [];

  return posts
    .filter((post) => !post.draft)
    .sort((a, b) => {
      const dateDiff =
        new Date(b.date).getTime() - new Date(a.date).getTime();
      if (dateDiff !== 0) return dateDiff;
      return (a.title || "").localeCompare(b.title || "");
    });
}

export function parseFrontmatter(markdownText) {
  const match = markdownText.match(/^---\n([\s\S]*?)\n---\n?/);
  if (!match) {
    return { body: markdownText, frontmatter: {} };
  }

  const frontmatter = {};
  const lines = match[1].split("\n");

  lines.forEach((line) => {
    const trimmed = line.trim();
    if (!trimmed || trimmed.startsWith("#")) return;
    const separatorIndex = trimmed.indexOf(":");
    if (separatorIndex < 1) return;
    const key = trimmed.slice(0, separatorIndex).trim();
    const value = trimmed.slice(separatorIndex + 1).trim();
    frontmatter[key] = normalizeFrontmatterValue(value);
  });

  return {
    frontmatter,
    body: markdownText.slice(match[0].length),
  };
}

function normalizeFrontmatterValue(value) {
  if (value === "true") return true;
  if (value === "false") return false;

  if (
    (value.startsWith('"') && value.endsWith('"')) ||
    (value.startsWith("'") && value.endsWith("'"))
  ) {
    return value.slice(1, -1);
  }

  if (value.startsWith("[") && value.endsWith("]")) {
    return value
      .slice(1, -1)
      .split(",")
      .map((item) => item.trim().replace(/^['"]|['"]$/g, ""))
      .filter(Boolean);
  }

  return value;
}
